"use client";

import AuthForm from "./AuthForm";
import StoreBox from "../store/store-box";

const AuthPage = (props) => {
  const { activateBackButton } = props;

  return (
    <StoreBox {...props} handleLocationChange={() => {}}>
      <div className="auth-container">
        <AuthForm
          defaultLogin={false}
          onBack={null}
          activateBackButton={activateBackButton}
        />
      </div>
    </StoreBox>
  );
};

export default AuthPage;
